import { Fragment } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { PecComunicazioneVO } from 'shell/models/pec';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { ManagementPecCrumbs } from 'civil-status/constants/breadcrumb';
import FormPec, { PecForm } from 'shell/components/shared/management-pec/pec-details/form';
import { transformPec } from 'shell/components/shared/management-pec/pec-details/utils/transformer-pec';
import { useEventCallback } from '@mui/material';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { transformSavePec } from 'shell/components/shared/management-pec/pec-details/utils/transform-save-pec';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';

const PecEditPage = (): React.ReactElement => {
  const params = useParams();

  const [pec] = useHttpFetch<HttpResponse<PecComunicazioneVO>, PecForm>(
    `${__ACT_API_URL__}/pec/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformPec,
    }
  );

  const navigate = useNavigate();

  const loadingPec = pec.isLoading || pec.pristine || pec.hasErrors;

  const onRedirect = useEventCallback(() => {
    navigate('/stato-civile/gestione-pec');
  });

  const saveData = useHttpClient(`${__ACT_API_URL__}/pec/reinvio`, {
    options: {
      method: 'POST',
      loading: true,
      errorCatching: true,
    },
  });

  const onOk = useEventCallback((values?: PecForm) => {
    const data = transformSavePec(values || {});

    (saveData({ data }) as unknown as ResponsePromise<void>).then(() => {
      toast.success('Operazione eseguita con successo');
      onRedirect();
    });
  });

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...ManagementPecCrumbs,
          {
            name: 'Invia di nuovo la PEC',
          },
        ]}
      />
      {loadingPec ? null : (
        <FormPec
          title="Invia di nuovo la PEC"
          onOk={onOk}
          onCancel={onRedirect}
          isEdit
          initialValues={pec.data as PecForm}
        />
      )}
    </Fragment>
  );
};

PecEditPage.displayName = 'Pec Edit page component';

export default PecEditPage;
